// src/components/ReactDataTable/ReactDataTable.jsx
import React, { useMemo, useState, useEffect } from 'react';
import { useTable, usePagination } from 'react-table';
import ReactPaginate from 'react-paginate';
import './style.css';
import { useDispatch, useSelector } from 'react-redux';
import { corporateEmployeeStatusAPI, corporateShowEmployeesAPI } from '../../redux/slices/CorporateAddEmployee';
import { Link, useParams } from 'react-router-dom';
import { ProfessionalAddTimingsAPI, ProfessionalDeleteSchaduleAPI, ProfessionalShowTimingsAPI } from '../../redux/slices/ProfessionalSheduleSlice';
import { toast } from 'react-toastify';
import { errorHandler } from '../../constants/base';


const ReactDataTable = () => {

    // GET ALL EMPLOYEES
    const user = useSelector((state) => state?.AuthSlice?.user);
    const allEmployees = useSelector((state) => state?.coporateAddEmployeSlice?.allEmployees);
    const employeeLoading = useSelector((state) => state?.coporateAddEmployeSlice?.employeeLoading);
    const pagination = useSelector((state) => state?.coporateAddEmployeSlice?.pagination);
    const [currentPage, setCurrentPage] = useState(pagination.current_page);

    const dispatch = useDispatch();

    const fetchEmployees = async () => {
        const corporateEmployees = {
            id: user?.id,
            page: currentPage,
        }

        try {
            await dispatch(corporateShowEmployeesAPI(corporateEmployees));
        } catch (error) {
            console.error("Error fetching employees:", error);
        }
    };

    useEffect(() => {
        fetchEmployees();
    }, [currentPage])

    const handlePageChange = (page) => {
        setCurrentPage(page);
    }

    // GET ALL EMPLOYEES


    const handleToggle = async (item) => {
        const coporate_id = user.id;
        const employee_id = item.id;
        const status = item.status === "Active" ? "Block" : "Active"
        await dispatch(corporateEmployeeStatusAPI({ coporate_id, employee_id, status }))
        await dispatch(corporateShowEmployeesAPI(user));
    };

    ////////////////////////////ADD SCHADULES///////////////////////////////
    const allTimings = useSelector((state) => state?.ProfessionalSheduleSlice?.allTimings)
    const loading = useSelector((state) => state?.ProfessionalSheduleSlice?.loading)
    const timeLoading = useSelector((state) => state?.ProfessionalSheduleSlice?.timeLoading)
    const [isValid, setIsValid] = useState(false);
    const [showTimeInputs, setShowTimeInputs] = useState(false)
    const [getEmployeID, setGetEmployeID] = useState(null)

    const getIdObj = {
        id: getEmployeID,
    }

    const fetchData = async () => {
        try {
            await dispatch(ProfessionalShowTimingsAPI(getIdObj));
        } catch (error) {
            console.error("Error fetching timings:", error);
        }
    }

    // USE EFFECTS
    useEffect(() => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            user_id: getEmployeID,
        }));
    }, [getEmployeID]);

    useEffect(() => {
        fetchData()
    }, [getEmployeID, allTimings.length])
    // USE EFFECTS

    const [formData, setFormData] = useState({
        day: '',
        start_time: '',
        end_time: '',
        // user_id: getEmployeID,
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const updatedFormData = { ...formData, [name]: value };
        setFormData(updatedFormData);
        validateForm(updatedFormData);
        setShowTimeInputs(true)
    };

    const validateForm = (data) => {
        const isFormValid = data.day && data.start_time && data.end_time;
        setIsValid(isFormValid);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const updatedFormData = { ...formData, user_id: getEmployeID };

        const res = await dispatch(ProfessionalAddTimingsAPI(updatedFormData));

        if (res.type === 'ProfessionalAddTimingsAPI/fulfilled') {
            if (res?.payload?.status === 200 || res?.data?.status) {
                toast.success("Time Slot Added Successfully");
                await dispatch(ProfessionalShowTimingsAPI(getIdObj));
                setShowTimeInputs(false);
            }
        } else if (res.type === 'ProfessionalAddTimingsAPI/rejected') {
            errorHandler(res.payload.errors);
        } else {
            toast.error('Sorry, something went wrong!');
        }
        setFormData({
            day: '',
            start_time: '',
            end_time: '',
            user_id: getEmployeID,
        });
        setIsValid(false);
    };

    // EDIT TIME SLOTS
    const [editableItem, setEditableItem] = useState(null);
    const [updatedData, setUpdatedData] = useState({});

    const formatTimeToInput = (time) => {
        if (!time) return "00:00";
        const [hours, minutes] = time.split(":");
        return `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}`;
    };

    const enableEdit = (item) => {
        setEditableItem(item.id);
        setUpdatedData({
            start_time: item.start_time,
            end_time: item.end_time,
            day: item.day,
            user_id: getEmployeID
        });
    };

    const handleTimeChange = (e, field) => {
        setUpdatedData((prev) => ({
            ...prev,
            [field]: e.target.value,
        }));
    };

    const updateTimeSlot = async () => {
        const formattedStartTime = formatTimeToInput(updatedData.start_time);
        const formattedEndTime = formatTimeToInput(updatedData.end_time);

        const updatedDataForApi = {
            ...updatedData,
            start_time: formattedStartTime,
            end_time: formattedEndTime,
        };

        const res = await dispatch(ProfessionalAddTimingsAPI(updatedDataForApi))
        if (res?.payload?.status === 200) {
            toast.success("Time Slote Update Successfully")
            await dispatch(ProfessionalShowTimingsAPI(getIdObj))
            setEditableItem(null);
        }
        setEditableItem(null);
    };

    // DELTE SCHADULE

    const [loadingId, setLoadingId] = useState(null);

    const deleteSchedule = async (id) => {
        setLoadingId(id);

        try {
            const res = await dispatch(ProfessionalDeleteSchaduleAPI(id))
            if (ProfessionalDeleteSchaduleAPI.fulfilled(res)) {
                toast.success("Schedule deleted successfully!");
                await dispatch(ProfessionalShowTimingsAPI(user));
            } else if (ProfessionalDeleteSchaduleAPI.rejected(res)) {
                toast.error("Something went wrong");
            }

        } catch (error) {
            toast.error("Failed to delete schedule.");
            console.error(error);
        } finally {
            setLoadingId(null);
        }
    }
    // DELTE SCHADULE

    return (
        <>
            <div className='table-responsive-custom'>
                {employeeLoading ? <div className='loading-icons'>
                    <i
                        style={{ fontSize: "52px" }}
                        className="fa-solid fa-spinner fa-spin"
                    ></i>
                </div> : <div>
                    <table className='my-employee-table'>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Phone No</th>
                                <th>Email</th>
                                <th>Services</th>
                                <th>Status</th>
                                <th>Schedule</th>
                                <th>Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {allEmployees?.map((item, index) => {
                                return <tr className='employee-tabel-box'>
                                    <td>{index + 1}</td>
                                    <td>{item.name}</td>
                                    <td>{item.phone_no}</td>
                                    <td>{item.email}</td>
                                    <td>{item?.services?.map((item) => item.name).join(", ")}</td>
                                    <td>
                                        {item.status === "Active" ? (
                                            <>
                                                <span className=''>{item.status}</span>
                                            </>
                                        ) : (
                                            <span className='text-danger'>{item.status}</span>
                                        )}
                                    </td>

                                    <td><button onClick={() => setGetEmployeID(item?.id)} data-bs-toggle="modal" href="#exampleModalToggle" role="button" className='btn btn-primary' style={{ whiteSpace: "nowrap" }}>Add</button></td>

                                    <td className='flex-toggle-box'>
                                        <Link to={`/corporate/employee/update/${item.id}`}>
                                            <i className="fa-regular fa-pen-to-square"></i>
                                        </Link>
                                        <div className="form-check form-switch">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                id="flexSwitchCheckChecked"
                                                checked={item.status === "Active" ? true : false}
                                                onChange={() => handleToggle(item)}
                                            />
                                            <label htmlFor="flexSwitchCheckChecked">

                                            </label>
                                        </div>
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </table>

                    <div className="pagination">
                        {pagination.current_page > 1 && (
                            <button onClick={() => handlePageChange(pagination.current_page - 1)}>&laquo; Previous</button>
                        )}

                        {[...Array(pagination.total_pages)].map((_, i) => (
                            pagination.total_pages >= 2 ?
                                <button
                                    key={i + 1}
                                    className={i + 1 === pagination.current_page ? 'active' : ''}
                                    onClick={() => handlePageChange(i + 1)}
                                >
                                    {i + 1}
                                </button> : ""
                        ))}

                        {pagination.current_page < pagination.total_pages && (
                            <button onClick={() => handlePageChange(pagination.current_page + 1)}>Next &raquo;</button>
                        )}
                    </div>
                </div>}
            </div>

            <div className="modal fade" data-bs-backdrop="static" id="exampleModalToggle" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabIndex={-1}>
                <div className="modal-dialog modal-dialog-centered service-add-model">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" id="click-close-btn" className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="fa-solid fa-xmark"></i></button>
                        </div>

                        <div className="modal-body">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="employee-form-box">
                                            <h1 className="mb-3">Work days & Time</h1>
                                        </div>

                                        <h3 className="second-text-heading">Select Week Days</h3>

                                        <form onSubmit={handleSubmit}>
                                            <div className="checkbox-group-blocks-label-wrap">
                                                <ul>
                                                    {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map((day) => (
                                                        <li key={day}>
                                                            <label>
                                                                <input
                                                                    type="radio"
                                                                    name="day"
                                                                    value={day}
                                                                    checked={formData.day === day}
                                                                    onChange={handleInputChange}
                                                                />
                                                                <span className="label-text model-bg-blue">{day}</span>
                                                            </label>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>

                                            {showTimeInputs ? <div>
                                                <h3 className="second-text-heading mt-5 mb-0">Select Timings</h3>
                                                <div className="flex-align-box-shedule">
                                                    <div className="select-timings-input">
                                                        <label htmlFor="selectStartTiming">Start Time</label>
                                                        <input
                                                            type="time"
                                                            name="start_time"
                                                            placeholder="Start Time"
                                                            id="selectStartTiming"
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>

                                                    <div className="select-timings-input mt-2">
                                                        <label htmlFor="selectEndTiming">End Time</label>
                                                        <input
                                                            type="time"
                                                            name="end_time"
                                                            placeholder="End Time"
                                                            id="selectEndTiming"
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>

                                                    <div className="d-flex justify-content-end">
                                                        <button type="submit" disabled={!isValid || loading} className="btn btn-primary ps-3 pe-3" id="nextBtn">
                                                            {!loading ? (
                                                                "Add Time"
                                                            ) : (
                                                                <i
                                                                    style={{ fontSize: "22px" }}
                                                                    className="fa-solid fa-spinner fa-spin"
                                                                ></i>
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div> : ""}
                                        </form>

                                        {/* {timeLoading ? <div className='loading-time-here'> <i
                                            style={{ fontSize: "22px" }}
                                            className="fa-solid fa-spinner fa-spin"
                                        ></i></div> : ""} */}

                                        <div className="time-slots" style={{ marginTop: '30px' }}>
                                            <h3 className="second-text-heading mt-5 mb-4">Timings</h3>
                                            {allTimings?.map((item) => (
                                                <div key={item.id} className="time-slot-day">
                                                    <h3 className="second-text-heading mt-4">{item.day}</h3>

                                                    <div className="show-time-slots">
                                                        <input
                                                            type="time"
                                                            disabled={editableItem !== item.id}
                                                            value={editableItem === item.id ? updatedData.start_time : formatTimeToInput(item.start_time)}
                                                            onChange={(e) => handleTimeChange(e, "start_time")}
                                                        />
                                                        <span>to</span>
                                                        <input
                                                            type="time"
                                                            disabled={editableItem !== item.id}
                                                            value={editableItem === item.id ? updatedData.end_time : formatTimeToInput(item.end_time)}
                                                            onChange={(e) => handleTimeChange(e, "end_time")}
                                                        />
                                                        {editableItem === item.id ? (
                                                            <div>
                                                                {!timeLoading ? (
                                                                    <i className="fa-solid fa-check" onClick={updateTimeSlot}></i>
                                                                ) : (
                                                                    <i
                                                                        style={{ fontSize: "22px" }}
                                                                        className="fa-solid fa-spinner fa-spin"
                                                                    ></i>
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <div className='d-flex'>
                                                                <i
                                                                    className="fa-solid fa-pen-to-square"
                                                                    onClick={() => enableEdit(item)}
                                                                ></i>

                                                                {!loadingId || loadingId !== item.id ? (
                                                                    <i
                                                                        className="fa-solid fa-trash"
                                                                        onClick={() => deleteSchedule(item.id)}
                                                                        style={{ color: "red" }}
                                                                    ></i>
                                                                ) : (
                                                                    <i
                                                                        style={{ fontSize: "22px", color: "red" }}
                                                                        className="fa-solid fa-spinner fa-spin"
                                                                    ></i>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ReactDataTable;
